<template>
  <div class="choicePaper">
    <div class="wrapperHead flex-row-center">
      <div class="wrapperHeadBox flex-row-space-between">
        <div class="flex-row-center" @click="goBack">
          <i style="font-size: 24px" class="el-icon-arrow-left"></i> 返回
        </div>
        <div class="wrapperHeadTitle">手动录入</div>
        <div>
          <div class="btn">保存</div>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="headBox flex-row-v-center">
        <div
          class="headItem flex-col-v-center"
          v-for="(item, index) in paperItem"
          :key="index"
          @click="selectImg(item, index)"
        >
          <div :class="{ imgBox: true, imgBoxActive: selectIndex == index }">
            <img :src="item" alt="" />
          </div>
          <div class="headItemTitle">
            第{{ index + 1 }}张 共{{ paperItem.length }}张
          </div>
        </div>
      </div>
      <div class="content">
        <div class="contentHead flex-row-v-center">
          <div>客观题 <span>35</span>/35</div>
          <div>主观题 <span>35</span>/35</div>
        </div>
        <div class="contentBox">
          <img :src="imgSrc" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      failDialogVisible: false,
      paperItem: [],
      selectIndex: 0,
      imgSrc: "",
      batch_id_by_class:"",
      homework_src_uuid:"",
      student_uuid:"",
    };
  },
  mounted() {
    this.batch_id_by_class = this.$route.query.batch_id_by_class;
    this.homework_src_uuid = this.$route.query.homework_src_uuid;
    this.student_id = this.$route.query.student_id;
    this.paperItem = JSON.parse(sessionStorage.getItem("paperItem"));
    this.imgSrc = this.paperItem[0];
    this.getBlankDetail();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    selectImg(item, index) {
      this.imgSrc = item;
      this.selectIndex = index;
    },
    getBlankDetail() {
      let params = {
        batch_id_by_class: this.batch_id_by_class,
      };
      this.axios.post("/school/homework_usages/blankDetail", params).then((res) => {
          if(res.data.code==1){
            console.log(JSON.parse(res.data.data.data))
          }
      });
    },
  },

  beforeDestroy() {},
};
</script>

<style scoped >
* {
  box-sizing: border-box;
}
.el-dialog {
  border-radius: 10px;
}
.el-dialog__title {
  font-size: 20px;
}
.choicePaper {
  width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
  background: #f2f2f2;
}
.wrapperHead {
  width: 100%;
  height: 72px;
  background: #ffffff;
  font-size: 16px;
}
.wrapperHeadTitle {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin: 0px 430px;
}
.wrapper {
  margin: 14px auto;
  width: 75vw;
}
.btn {
  padding: 14px 28px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fefefe;
  background: #ff9b36;
  border-radius: 4px;
  cursor: pointer;
}
.wrapperHeadBox {
  width: 1440px;
}
.headBox {
  padding: 12px;
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 14px;
}
.headItem {
  cursor: pointer;
}
.imgBox {
  width: 278px;
  height: 159px;
  border-radius: 8px;
  background: #ffffff;
  margin-bottom: 8px;
  box-sizing: border-box;
  margin-right: 5px;
}
.imgBox img {
  width: 100%;
  height: 100%;
}
.imgBoxActive {
  border: 2px solid #54a9fd;
}
.headItemTitle {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
}
.content {
  width: 100%;
  height: 740px;
  background: #ffffff;
  border-radius: 12px 12px 0px 0px;
  padding: 0px 20px;
}
.contentHead {
  padding: 25px 0px;
}
.contentHead {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.contentHead > div {
  margin-right: 48px;
}
.contentBox {
  height: 566px;
  border-radius: 12px 12px 0px 0px;
  border: 2px solid #54a9fd;
  overflow-x: auto;
  overflow-y: auto;
}
.contentBox img {
  width: 100%;
}
</style>